import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import RadioButton from "components/radioButton";

import styles from "./tabsChoose.module.scss";

const InterchangePlus = () => {
	return (
		<div>
			<div className={styles.subHeader}>Interchange Plus</div>
			<div className={styles.addressTitle}>Gross / Net</div>
			<Row>
				<Col md={12}>
					<div className="d-flex">
						<Field
							component={RadioButton}
							value="0"
							className={styles.radioButton}
							name="interchangePlusRevenueType"
							label="Gross"
							type="radio"
							id="revenueTypeGross"
						/>
						<Field
							component={RadioButton}
							value="1"
							className={styles.radioButton}
							name="interchangePlusRevenueType"
							label="Net"
							type="radio"
							id="revenueTypeNet"
						/>
					</div>
				</Col>
			</Row>
		</div>
	);
};

export default memo(InterchangePlus);
